import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux"
import { Helmet } from '../components/helmet/Helmet'
import {db} from '../firebase_setup/firebase';
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { cartActions } from '../redux/slices/cartSlice';
import processing from '../assets/images/loading.gif'
import CartSection from '../components/UI/CartSection';
import AddressSection from '../components/UI/AddressSection';
import { firebaseQuery } from '../functions/firebaseQuery';

import '../styles/checkout.css';


export const Test = (props) => {
  const cusName = 'Tom'
  const orderId = '5oEdxM8aiRHlkztVbmJ3'
  const amount_total = 119.98
  const discount = 19.98
  const cartItems = [{"quantity":3,"totalPrice":419.97,"price":139.99,"name":"The Wicker Man","id":"prod_NpA8g4QW3mjD7d"},{"quantity":5,"totalPrice":199.95000000000002,"price":39.99,"name":"The Swimmer","id":"prod_NpA8g4QW3mjD7e"}]
  const shippingAddress = 
  {"0":{"zip":"","country":"Australia","lastName":"Chan","firstName":"Tom","address2":"","phone":"","city":"Parramatta","address1":"10 Geroge St","company":"","state":"New South Wales"},"1":{"zip":"","country":"Australia","lastName":"saas","firstName":"sasa","phone":"","address2":"","city":"Parramatta","address1":"1 Geroge St","company":"","state":"New South Wales"},"2":{"zip":"","firstName":"","lastName":"","country":"Australia","city":"Parramatta","address2":"","phone":"","address1":"100 Geroge St","company":"","state":"New South Wales"},"3":{"zip":"","firstName":"","country":"Australia","lastName":"","phone":"","address2":"","city":"Parramatta","address1":"20 Geroge St","company":"","state":"New South Wales"},"default":0,"selected":0}
  const paymentMethod = {"id":"pm_1OaH5nHlpGuoLlem9XN1ghyZ","object":"payment_method","billing_details":{"address":{"city":null,"country":"AU","line1":null,"line2":null,"postal_code":null,"state":null},"email":"testtesttest@gmail.com","name":"Peter","phone":null},"card":{"brand":"visa","checks":{"address_line1_check":null,"address_postal_code_check":null,"cvc_check":"pass"},"country":"US","exp_month":12,"exp_year":2034,"fingerprint":"w48GKq6fZP06XqOw","funding":"credit","generated_from":null,"last4":"4242","networks":{"available":["visa"],"preferred":null},"three_d_secure_usage":{"supported":true},"wallet":null},"created":1705666959,"customer":null,"livemode":false,"metadata":{},"type":"card"}
  return (
    <Helmet title='Shipping'>
        <div class="email-container">
            <h2>Thank you for your purchase!</h2>
            <p>Hi {cusName}, we're getting your order ready to be shipped. We will notify you when it has been sent.</p>
            <p>Order #{orderId}</p>
            <p>{amount_total}</p>
            <p>{discount}</p>
            <p>{JSON.stringify(cartItems)}</p>
            <p>{JSON.stringify(shippingAddress)}</p>
            <p>{JSON.stringify(paymentMethod)}</p>
          </div>
    </Helmet>

  )
}
